import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { RevaluationDetail } from './RevaluationDetail/RevaluationDetail'
import { RevaluationForm } from './RevaluationForm/RevaluationForm'
import { RevaluationMain } from './RevaluationMain'

const revaluationRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/revaluation/filter',
    },
    component: (
      <AdvancedFilter
        mode="revaluation"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/revaluation',
    },
    component: <RevaluationMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/revaluation/add',
    },
    component: <RevaluationForm formMode="add" />,
  },
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/revaluation/edit',
    },
    component: <RevaluationForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/revaluation/resubmit',
    },
    component: <RevaluationForm formMode="resubmit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/revaluation/detail',
    },
    component: <RevaluationDetail />,
  },
]

export default revaluationRoutes
